import React from 'react';
import className from 'classnames';
import TableHeader from '../TableHeader';

const BagsList = ({
  bags, total
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Bags list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} bags</p>
        </div>
      </div>

      <div
        className={className('Table', {
          'Table--bags-list': true
        })}
      >
        {(() => {
          let columnHeaders = [
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'Yay user id',
              sortKey: 'yay_user_id'
            },
            {
              label: 'Eggs count',
              sortKey: 'eggs_count'
            },
            {
              label: 'Pals count',
              sortKey: 'pals_count'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {bags.map((bag) => (
          <div className='Table__row' key={bag.id} data-x={bag}>
          <div className='Table__col'>
            <a
              className='Table__a'
              href={`/${gon.currentProvider}/bag/${bag.id}`}
            >
              {bag.id}
            </a>
          </div>
          <div className='Table__col'>
            <a
              className='Table__a'
              href={`/yay/users/${bag.yayUserId}`}
            >
              {bag.yayUserId}
            </a>
          </div>
          <div className='Table__col'>{bag.eggsCount}</div>
          <div className='Table__col'>{bag.palsCount}</div>
        </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default BagsList;
